import React, { useMemo } from "react";
import { Flex } from "reflexbox";
import { Body } from "../UI/Text";
import formatter from "../../modules/formatter";

const PriceDisplay = ({ row, isUnit }) => {
  const { price, quantity } = row || {};
  return (
    <Flex
      height="100%"
      justifyContent={"flex-end"}
      alignItems="center"
      flexWrap="wrap"
      key={row?.id + "|price"}
    >
      <Body right>${formatter.currency(price * (isUnit ? 1 : quantity))}</Body>
    </Flex>
  );
};

export default PriceDisplay;
